module.exports = __webpack_public_path__ + "static/media/08.9137a8b2.png";